import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { AppDatePicker } from "@/shared/Components";
import type { Dayjs } from "dayjs";
import styles from "./styles.module.scss";

export type DateFilterProps = {
  onChangeFrom: (date: Dayjs, dateString: string | string[]) => void;
  onChangeTo: (date: Dayjs, dateString: string | string[]) => void;
  defaultValueFrom?: Dayjs | null;
  defaultValueTo?: Dayjs | null;
};

export const DateFilter: FC<DateFilterProps> = ({
  onChangeFrom,
  onChangeTo,
  defaultValueFrom,
  defaultValueTo,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles["select-wrapper"]}>
        {t("common.from")}
        <AppDatePicker
          format={{
            format: "DD-MM-YYYY",
            type: "mask",
          }}
          defaultValue={defaultValueFrom}
          onChange={onChangeFrom}
        />
      </div>
      <div className={styles["select-wrapper"]}>
        {t("common.to")}
        <AppDatePicker
          format={{
            format: "DD-MM-YYYY",
            type: "mask",
          }}
          defaultValue={defaultValueTo}
          onChange={onChangeTo}
        />
      </div>
    </div>
  );
};
